import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ArrowDownIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        id="Vector"
        d="M8.59898 10.2497C8.5223 10.3329 8.43442 10.3956 8.33532 10.4376C8.23682 10.4792 8.12505 10.5 8 10.5C7.87495 10.5 7.76318 10.4792 7.66468 10.4376C7.56617 10.396 7.47829 10.3334 7.40102 10.2497L4.09821 6.32931C4.06577 6.28413 4.04129 6.23649 4.02477 6.18639C4.00826 6.13629 4 6.08866 4 6.04348C4 5.89766 4.06488 5.77062 4.19465 5.66237C4.32441 5.55412 4.49782 5.5 4.71489 5.5L11.2851 5.5C11.5022 5.5 11.6756 5.55435 11.8054 5.66304C11.9351 5.77219 12 5.89945 12 6.04482C12 6.09 11.9917 6.13741 11.9752 6.18706C11.9593 6.23672 11.9348 6.28413 11.9018 6.32931L8.59898 10.2497Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

ArrowDownIcon.displayName = 'ArrowDownIcon';
